export const PlatformDefaultValue: IPlatform["get"] = {
    id: 0,
    faName: "",
    enName: "",
    image: "",
    url: "",
    description: "",
    seoDescription: "",
    seoKeywords: "",
    updateDateTime: "",
    createDateTime: "",
};
